import UModal from './UModal'

export default {
    install(app) {
        app.component("UModal", UModal)
    }
}
